export const PREFERRED_INSTITUTE_NUMBER_COOKIE_NAME = 'preferredInstituteNumber';
export const PREFERRED_INSTITUTE_COOKIE_NAME = 'preferredInstitute';
